// Fixed 12-color player palette. One color per max player slot (§7) - this is why
// maxPlayers is hardcoded rather than configurable (see ARCHITECTURE.md). Evenly
// spaced around the hue wheel at a consistent, moderate saturation/lightness
// (62%/54%) - distinct and "basic" without being neon-harsh. Already sorted by hue,
// which the join screen's color grid relies on.
export const PLAYER_COLORS: readonly string[] = [
  "#d24141", // red
  "#d28541", // orange
  "#d2ae41", // gold
  "#aed241", // yellow-green
  "#41d259", // green
  "#41d2b5", // teal
  "#41aed2", // sky blue
  "#4171d2", // blue
  "#5441d2", // indigo
  "#9641d2", // violet
  "#d241c6", // magenta
  "#d2417e", // rose
];

// 26-color canvas drawing palette (§9 Drawing Phase).
export const CANVAS_COLORS: readonly string[] = [
  "#000000", // black
  "#ffffff", // white
  "#808080", // gray
  "#c0c0c0", // silver
  "#ef4444", // red
  "#f97316", // orange
  "#f59e0b", // amber
  "#fde047", // yellow
  "#a3e635", // lime
  "#22c55e", // green
  "#10b981", // emerald
  "#14b8a6", // teal
  "#06b6d4", // cyan
  "#3b82f6", // blue
  "#6366f1", // indigo
  "#8b5cf6", // violet
  "#a855f7", // purple
  "#d946ef", // fuchsia
  "#ec4899", // pink
  "#f43f5e", // rose
  "#7c2d12", // brown
  "#92400e", // dark orange
  "#451a03", // dark brown
  "#fed7aa", // peach
  "#1e293b", // dark slate
  "#64748b", // slate gray
];

export const MAX_PLAYERS = PLAYER_COLORS.length;

export const CANVAS_WIDTH = 1100;
export const CANVAS_HEIGHT = 750;
